import React from 'react';
import { Dropdown, DropdownDivider, DropdownItem } from '../../../dropdown';
import IconButton from '../../../button/iconButton';
import Avatar from '../../../avatar';
import { AVATAR_BORDER, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../../global/constants';
import { ChatGroupInterface, UserInterface } from '../../../../interfaces/chatMessageInterface';
import { AssignContent, AssignGroup, Plus, ItemDiv } from '../styles';

interface WorkspaceInterface {
  isAdmin?: boolean;
  isOwner?: boolean;
  id?: string;
}

interface MemberDropdownProps {
  currentChatGroup: ChatGroupInterface | null;
  currentUser: UserInterface | null;
  currentWorkspace: WorkspaceInterface | null;
  mobile: boolean;
  memberIconRef: React.RefObject<HTMLDivElement>;
  onOpenAddMemberModal: () => void;
  onRemoveMember: (userId: string) => void;
}

export const MemberDropdown: React.FC<MemberDropdownProps> = ({
  currentChatGroup,
  currentUser,
  currentWorkspace,
  mobile,
  memberIconRef,
  onOpenAddMemberModal,
  onRemoveMember
}) => {
  if (!currentChatGroup?.users || currentChatGroup?.users?.length <= 1) {
    return null;
  }

  const userCount = currentChatGroup?.users?.length || 0;
  const avatarLimit = mobile ? 3 : 5;
  const displayLimit = mobile ? 2 : 4;

  return (
    <Dropdown
      modalTitle='Members'
      isMinWidth={186}
      content={
        mobile ? (
          <IconButton iconName='customer-icon' size={ICON_BUTTON_SIZE.LARGE} variant={ICON_BUTTON_TYPE.TERTIARY} />
        ) : (
          <AssignContent
            role='button'
            ref={memberIconRef}
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
              }
            }}>
            <AssignGroup>
              <ul>
                {currentChatGroup?.users?.map((user, index) => {
                  if (index > displayLimit) return null;
                  return (
                    <li key={user?.id}>
                      <Avatar
                        imgSrc={user?.profile_photo || ''}
                        name={user?.name ? user.name : 'U N'}
                        size={24}
                        borderVariant={AVATAR_BORDER.THIN}
                      />
                    </li>
                  );
                })}
                {userCount > avatarLimit && (
                  <li className='plus-icon'>
                    <Plus>+{userCount - avatarLimit}</Plus>
                  </li>
                )}
              </ul>
            </AssignGroup>
          </AssignContent>
        )
      }
      trigger='hover'>
      <>
        <ItemDiv>
          {currentChatGroup?.users.map((user) => {
            const isShowRemoveIcon =
              user?.id !== currentUser?.id &&
              currentChatGroup?.users &&
              currentChatGroup?.users.length > 2 &&
              (currentChatGroup?.createdBy === currentUser?.id ||
                currentWorkspace?.isAdmin ||
                currentWorkspace?.isOwner);

            return (
              <DropdownItem
                key={user?.id}
                label={user.name}
                isAvatar
                avatarSrc={user.profile_photo}
                isSuffixCross={isShowRemoveIcon}
                onSuffixClick={() => onRemoveMember(user?.id)}
                isSuffixIcon={true}
              />
            );
          })}
        </ItemDiv>
        <DropdownDivider />
        <DropdownItem
          label='Add Member'
          iconName='member-plus-icon'
          iconSize={20}
          iconViewBox='0 0 18 18'
          onClick={onOpenAddMemberModal}
        />
      </>
    </Dropdown>
  );
};

export default MemberDropdown;
